import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider, RequireAdminAuth } from './hooks/useAdminAuth';

import LoginPage         from './pages/LoginPage';
import DashboardPage     from './pages/DashboardPage';
import AdminDoctorsPage  from './pages/AdminDoctorsPage';
import AdminServicesPage from './pages/AdminServicesPage';
import AdminBlogPage     from './pages/AdminBlogPage';
import AdminAppointmentsPage from './pages/AdminAppointmentsPage';

const AdminApp = () => (
  <AdminAuthProvider>
    <Routes>
      {/* Public admin route */}
      <Route path="login" element={<LoginPage />} />

      {/* Protected admin routes */}
      <Route path="dashboard" element={<RequireAdminAuth><DashboardPage /></RequireAdminAuth>} />
      <Route path="doctors"   element={<RequireAdminAuth><AdminDoctorsPage /></RequireAdminAuth>} />
      <Route path="services"  element={<RequireAdminAuth><AdminServicesPage /></RequireAdminAuth>} />
      <Route path="blog"      element={<RequireAdminAuth><AdminBlogPage /></RequireAdminAuth>} />
      <Route path="appointments" element={<RequireAdminAuth><AdminAppointmentsPage /></RequireAdminAuth>} />

      {/* Default redirect */}
      <Route path="*" element={<Navigate to="/admin/login" replace />} />
    </Routes>
  </AdminAuthProvider>
);

export default AdminApp;
